import "./styles.scss";

import { useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { useTranslation } from "react-i18next";
import classnames from "classnames";

import AvatarImage from "assets/images/avatar-placeholder.png";

const mainClass = "avatar-uploader";

const file_types = ["JPG", "PNG", "JPEG"];
const file_max_size = 1;

const generateBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const AvatarUploader = ({
  data,
  photo,
  photo_progress,
  loading,
  disabled,
  setFile,
  setPhoto,
}) => {
  const { t } = useTranslation();

  const [error, setError] = useState(null);

  const onChange = async (file) => {
    setError(null);
    const photo = await generateBase64(file[0]);

    if (typeof setPhoto === "function") setPhoto(photo);
    if (typeof setFile === "function") setFile(file[0]);
  };

  return (
    <div
      className={classnames(mainClass, {
        [`${mainClass}--loading`]: !!loading,
        [`${mainClass}--disabled`]: !!disabled,
      })}
    >
      <FileUploader
        classes={`${mainClass}__label`}
        multiple={true}
        handleChange={onChange}
        name="file"
        types={file_types}
        maxSize={file_max_size}
        onSizeError={() =>
          setError(t("The file is too large. Allowed maximum size is 1MB."))
        }
        hoverTitle=" "
      >
        <div className={`${mainClass}__image`}>
          <div className={`${mainClass}__image-inner`}>
            <img
              src={photo || data?.photo?.location || data?.photo || AvatarImage}
              alt=""
            />
            {!!loading && (
              <div className={`${mainClass}__loader`}>{photo_progress}</div>
            )}
          </div>
        </div>
        <div className={`${mainClass}__info`}>
          <p>{t("Click the photo to update it.")}</p>
          <small>
            {t("Acceptable format: jpg, png.")} {t("Max size: 1MB.")}
          </small>
          {!!error && <small className={`${mainClass}__error`}>{error}</small>}
        </div>
      </FileUploader>
    </div>
  );
};

export default AvatarUploader;
